import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { 
  Megaphone, 
  Plus,
  Edit,
  Eye,
  Calendar
} from 'lucide-react';
import { toast } from 'sonner';

const AdminNewsPage = () => {
  const [news, setNews] = useState([
    { id: '1', title: 'Lancement de notre nouvelle offre', date: '2025-01-15', published: true },
    { id: '2', title: 'Retour sur le salon WebExpo 2025', date: '2025-01-10', published: true },
    { id: '3', title: 'Nouvelle certification obtenue', date: '2025-01-05', published: false },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">Actualités</h1>
          <p className="text-[#64748b]">Gérez les articles de votre blog</p>
        </div>
        <Button className="bg-amber-600 hover:bg-amber-700">
          <Plus className="w-4 h-4 mr-2" />
          Nouvel article
        </Button>
      </div>

      <div className="space-y-4">
        {news.map((article) => (
          <Card key={article.id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
                    <Megaphone className="w-5 h-5 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1a365d]">{article.title}</h3>
                    <div className="flex items-center gap-2 text-sm text-[#64748b]">
                      <Calendar className="w-3 h-3" />
                      <span>{new Date(article.date).toLocaleDateString('fr-FR')}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Badge variant={article.published ? 'default' : 'secondary'}>
                    {article.published ? 'Publié' : 'Brouillon'}
                  </Badge>
                  <Button variant="ghost" size="icon"><Eye className="w-4 h-4" /></Button>
                  <Button variant="ghost" size="icon"><Edit className="w-4 h-4" /></Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminNewsPage;
